import React from "react";
import PaymentButton from "../PaymentButton";
import CustomSelect, { CustomSelectChoose } from "../Selector";
import { GENDERTYPE } from "../../contexts/SaveDataContext";
import { timeOptionsMain } from "../../utils/data";
import { CustomFormatInput } from "../Input";

interface Step1InputFormProps {
  value: {
    name: string;
    birth: string;
    time: string;
    leap: string;
    gender: string;
    question: string;
  };
  onChange: (val: Step1InputFormProps["value"]) => void;
  onNext: () => void;
  onBack: () => void;
}

function Step1InputForm({
  value,
  onChange,
  onNext,
  onBack,
}: Step1InputFormProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(value);
    // birth 검증할때 숫자만남겨서 19990101 여덟자리 안돼면 안됌.

    if (
      value.birth.replace(/\D/g, "").length !== 8 ||
      !value.birth ||
      !value.time ||
      !value.leap ||
      !value.gender ||
      !value.question.trim() ||
      !value.name.trim()
    ) {
      alert(
        "이름, 년월일, 시, 양/음/윤, 성별, 상담 시 궁금한 내용을 모두 입력해 주세요."
      );
      return;
    }
    onNext();
  };

  return (
    <main className="flex flex-col items-center bg-[#F9F9FC] relative">
      <button
        className="absolute -top-4 left-4 text-[#222] text-base"
        onClick={onBack}
      >
        뒤로가기
      </button>
      <h2 className="text-2xl font-bold mb-8">사주 정보 입력하기</h2>
      <form
        className="w-full max-w-[320px] flex flex-col gap-4"
        onSubmit={handleSubmit}
      >
        <div className="flex flex-col gap-1">
          <label className="text-sm text-[#222]">이름</label>
          <input
            maxLength={10}
            type={"text"}
            name={"name"}
            placeholder="홍길동"
            className="border border-black rounded-lg  text-lg bg-white  placeholder:text-[#BDBDBD] w-full h-[54px] text-left outline-none px-1 py-2"
            value={value.name}
            onChange={(e) =>
              onChange({ ...value, name: e.currentTarget.value })
            }
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm text-[#222]">년월일</label>
          <CustomFormatInput
            maxLength={10}
            type={"tel"}
            name={"yearMonthDay"}
            placeholder="1999/01/22"
            className="col-span-5 h-[54px] !border !border-black !rounded-md"
            value={value.birth}
            onChange={(e) =>
              onChange({ ...value, birth: e.currentTarget.value })
            }
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm text-[#222]">시 선택</label>
          <CustomSelectChoose
            options={timeOptionsMain}
            className="col-span-2 sm:col-span-1 h-[54px] bg-white !border !border-black !rounded-md"
            value={value.time}
            onChange={(e) =>
              onChange({ ...value, time: e.currentTarget.value })
            }
          />
        </div>

        <div className="grid grid-cols-2 col-span-2 gap-2 sm:col-span-1">
          <div className="flex flex-col gap-1">
            <label className="text-sm text-[#222]">양,음,윤</label>
            <CustomSelect
              options={[
                { key: "양력", value: "SOLAR" },
                { key: "음력", value: "LUNAR" },
                { key: "윤달", value: "LEAP" },
              ]}
              className="col-span-1 h-[54px] bg-white !border !border-black !rounded-md"
              value={value.leap}
              onChange={(e) =>
                onChange({ ...value, leap: e.currentTarget.value })
              }
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-sm text-[#222]">성별</label>
            <CustomSelect
              options={[
                { key: "남", value: "MALE" },
                { key: "여", value: "FEMALE" },
              ]}
              value={value.gender}
              onChange={(e) => {
                onChange({
                  ...value,
                  gender: e.currentTarget.value as GENDERTYPE,
                });
              }}
              className=" col-span-1 h-[54px] bg-white  !border !border-black !rounded-md"
            />
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm text-[#222]">
            상담 시 궁금한 내용(100자 제한)
          </label>
          <textarea
            maxLength={100}
            value={value.question}
            onChange={(e) => onChange({ ...value, question: e.target.value })}
            placeholder="대운 풀이, 연애운이 궁금해요"
            className="w-full border border-black rounded-lg px-4 py-3 text-lg bg-white min-h-[100px] placeholder:text-[#BDBDBD]"
          />
          <span className="text-sm text-[#222] text-right">
            {value.question.length}/100
          </span>
        </div>

        <PaymentButton
          className=" bg-[#9D7FDE] text-white text-xl mt-4 shadow-none hover:brightness-95 h-[48px] !rounded-md"
          type="submit"
        >
          확인
        </PaymentButton>
      </form>
    </main>
  );
}

export default Step1InputForm;
